/**
 * Shared utilities for model-selector components.
 */

export const ORIENTATION_LABELS: Record<'landscape' | 'portrait' | 'square', string> = {
  landscape: 'Landscape',
  portrait: 'Portrait',
  square: 'Square',
};

export function deriveOrientation(
  resolution: string | null | undefined
): 'landscape' | 'portrait' | 'square' | null {
  if (!resolution) return null;
  const match = resolution.match(/^(\d+)\s*[x×]\s*(\d+)$/i);
  if (!match) return null;
  const width = parseInt(match[1], 10);
  const height = parseInt(match[2], 10);
  if (!Number.isFinite(width) || !Number.isFinite(height)) return null;
  if (width > height) return 'landscape';
  if (height > width) return 'portrait';
  return 'square';
}

export function formatCount(count: number): string {
  if (count >= 1_000_000) return `${(count / 1_000_000).toFixed(1)}M`;
  if (count >= 1_000) return `${(count / 1_000).toFixed(1)}K`;
  return String(count);
}
